export default __webpack_public_path__ + "static/media/pro.3234ed83.webp";